import React from "react";
import "../Contact/Contact.css";
import Connect from "../Connect/Connect";
import Reach from "./Reach";
const Contact = () => {
  return (
    <>
      <div className="about-us-c">
        <div className="overlay-a-c">
          <div className="text-container-c">
            <h1>Connect with Us for Exceptional Plants</h1>
            <p>
              Explore a curated selection of premium plants to enhance your home
              or workspace. Reach out to us for expert guidance.
            </p>
            <button className="animated-button-c">Contact Us</button>
          </div>
        </div>
        <img
          src="contact.webp"
          alt="About Us Poster"
          className="poster-image-c"
        />
      </div>
      <Connect />
      <Reach />
    </>
  );
};

export default Contact;
